<template>
    <button
        class="text_align_btn"
        :class="`text_align_${direction}_btn`"
        @click="alignText(direction)"
    >
        <inline-svg
            :src="alignIcon"
            fill="#737373"
        />
    </button>
</template>

<script>
    export default {
        methods: {
            alignText(direction) {
                let payload = {
                    variableName: 'align',
                    value: direction
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            }
        },
        props: {
            direction: String,
            alignIcon: String
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .text_align_btn {
        background-color: #f5f5f5;
        border: none;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
</style>